<template>
  <div class="spl-match-scan">
    <div>
      <form-label>Event Type</form-label>
      <form-filtered-select
        ref="eventType"
        v-model="eventInfoID"
        class="spl-scan-modal__event-type"
        :options="eventInfoOptions"
        :selected-key="eventInfoID"
        :invalid="$v.eventInfoID.$error"
        @close="$v.eventInfoID.$touch" />
    </div>
    <div>
      <form-label>Return Barcode</form-label>
      <input
        ref="returnBarcode"
        v-model="returnBarcode"
        :class="['spl-input', 'spl-match-scan__return-barcode']"
        type="text"
        @keyup.enter="returnBarcodeEntered"
        @blur="$v.returnBarcode.$touch()">
      <span v-if="$v.returnBarcode.$error" class="error">Return Barcode must be valid.</span>
    </div>
    <div>
      <form-label>Original Barcode</form-label>
      <input
        ref="originalBarcode"
        v-model="originalBarcode"
        :class="['spl-input', 'spl-match-scan__original-barcode']"
        type="text">
    </div>
    <div>
      <form-label />
      <form-button class="spl-match-scan__scan-parcel" @onClick="scanParcel">
        Scan Parcel
      </form-button>
    </div>
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { required, minValue } from 'vuelidate/lib/validators'
import webApi from '@/webApi'
import moment from 'moment'

export default {
  props: ['manifestRegExes'],
  data () {
    return {
      eventInfoID: -1,
      returnBarcode: '',
      originalBarcode: '',
      isLoading: false
    }
  },
  computed: {
    ...mapState('eventInfo', ['eventInfoOptions']),
    ...mapGetters('user', ['getClaimByType'])
  },
  mounted () {
    this.$refs.returnBarcode.focus()
    var userDefaultEvent = this.getClaimByType(
      'Return_Match_Scan_Default_Event_Info_ID'
    )
    if (this.eventInfoOptions && userDefaultEvent && userDefaultEvent[0]) {
      this.eventInfoID = parseInt(userDefaultEvent[0], 10)
    }
  },
  validations: {
    eventInfoID: {
      required,
      minValue: minValue(0)
    },
    returnBarcode: {
      required
    }
  },
  methods: {
    // SIM123456789123456
    returnBarcodeEntered () {
      this.$v.returnBarcode.$touch()
      this.$refs.originalBarcode.focus()
    },

    scanParcel () {
      this.isLoading = true
      webApi.scan
        .scan_Parcel({
          Barcode: this.returnBarcode,
          Matched_Barcode: this.originalBarcode,
          Event_Info_ID: this.eventInfoID,
          Timestamp: moment().toISOString(true),
          Is_Forward: false,
          Matched_Barcode_Reference_Type_ID: 1,
          Create_Parcel_If_Not_Existing: true
        })
        .then((result) => {
          this.isLoading = false
          this.$emit('matchScanned', result.data)
        })
        .catch(() => {
          this.isLoading = false
          this.$toast('Match Scan has failed', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'center',
            mode: 'override',
            className: ['spl-error-toast']
          })
        })
      this.returnBarcode = ''
      this.originalBarcode = ''
      this.$v.$reset()
      this.$refs.returnBarcode.$el.focus()
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";

.spl-match-scan {
  display: flex;
  flex-direction: row;
  background-color: $yellowButtonLabelHover;
  height: 97px;
  padding: 12px $mainPadding;

  & > div {
    width: 20%;
    max-width: 250px;
    margin-right: 10px;
  }

  & .error {
    margin-top: -11px;
  }
}
</style>
